import React, { useEffect } from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  withDelay,
} from "react-native-reanimated";
import { Ionicons } from "@expo/vector-icons";

type Props = {
  active?: boolean;
};

const RippleAnimation: React.FC<Props> = ({ active = true }) => {
  const scale1 = useSharedValue(1);
  const opacity1 = useSharedValue(0.2);
  const scale2 = useSharedValue(1);
  const opacity2 = useSharedValue(0.1);

  useEffect(() => {
    if (active) {
      // First ripple - starts immediately
      scale1.value = withRepeat(
        withTiming(1.92, { duration: 1500 }),
        -1,
        false
      );
      opacity1.value = withRepeat(withTiming(0, { duration: 1500 }), -1, false);

      // Second ripple - starts 750ms later
      scale2.value = withRepeat(
        withDelay(0, withTiming(2.79, { duration: 1500 })),
        -1,
        false
      );
      opacity2.value = withRepeat(
        withDelay(0, withTiming(0, { duration: 1500 })),
        -1,
        false
      );
    } else {
      scale1.value = 1;
      opacity1.value = 0.2;
      scale2.value = 1;
      opacity2.value = 0.1;
    }
  }, [active, scale1, opacity1, scale2, opacity2]);

  const animatedStyle1 = useAnimatedStyle(() => ({
    transform: [{ scale: scale1.value }],
    opacity: opacity1.value,
  }));

  const animatedStyle2 = useAnimatedStyle(() => ({
    transform: [{ scale: scale2.value }],
    opacity: opacity2.value,
  }));

  return (
    <View style={styles.container}>
      {/* First ripple */}
      <Animated.View style={[styles.ripple, animatedStyle1]} />

      {/* Second ripple */}
      <Animated.View style={[styles.ripple2, animatedStyle2]} />

      {/* Inner circle (48x48) - static */}
      <View style={styles.innerCircle}>
        <Ionicons name="call" size={18} color="white" />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 134,
    height: 134,
    justifyContent: "center",
    alignItems: "center",
  },
  ripple: {
    position: "absolute",
    width: 48,
    height: 48,
    borderRadius: 100,
    backgroundColor: "#0F9129",
  },
  ripple2: {
    position: "absolute",
    width: 48,
    height: 48,
    borderRadius: 134,
    backgroundColor: "#0F9129",
  },
  innerCircle: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "#0F9129",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
});

export default RippleAnimation;
